<template>
  <v-list>
    <div
      :key="item.title"
      v-for="item in items">
      <v-list-group
        :disabled="item.disabled"
        :prepend-icon="item.icon"
        @click="routeTo(item.route)"
        no-icon
        v-if="typeof item.items !== 'undefined'"
        v-model="item.active"
      >
        <v-list-item @click="routeTo('merchant')" slot="activator">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :key="subItem.title"
          @click="routeTo(subItem.route)"

          v-for="subItem in item.items"
          :value="$route.name === subItem.route"
        >
          <v-list-item-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>

        </v-list-item>
      </v-list-group>
      <v-list-item
        @click="routeTo(item.route)"
        v-else
        :value="$route.name === item.route"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>

      </v-list-item>
    </div>

  </v-list>
</template>

<script>
export default {
  name: 'MainMenu',
  data() {
    return {
      items: [
        {
          icon: 'far fa-smile',
          title: 'Organisaties',
          route: 'organisations',
        },
        {
          icon: 'far fa-industry',
          title: 'Fabrikanten',
          route: 'manufacturers',
        },
        {
          icon: 'far fa-network-wired',
          title: 'Derde partijen',
          route: 'third-parties',
        },
        {
          icon: 'far fa-users',
          title: 'Gebruikers',
          route: 'users',
        },
        {
          icon: 'far fa-clock',
          title: 'Tijdlijn',
          route: 'timeline',
        },
        {
          icon: 'far fa-chart-area',
          title: 'Beacons',
          route: 'beacons',
        },

      ],
    };
  },
  methods: {
    routeTo(name) {
      this.$router.push({name: name});
    },
  },
};
</script>

<style scoped>
</style>
